// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__15gqg","box":"WorkspacesBox_box__2aZLG","node":"WorkspacesBox_node__3TJOi"};